module.exports = __webpack_public_path__ + "static/media/25b Closed Guard.6145f8ce.jpg";